(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dio-hoodie-details"] && !Shopify.designMode) return;
  try {
    
  const dioSection = document.querySelector('.dio-details[data-sold-out="true"]');
  if (dioSection) {
    const notice = dioSection.querySelector('.dio-details__stock-notice');
    const addButton = document.querySelector('[data-add-button]');
    if (notice && addButton) {
      addButton.before(notice);
      notice.hidden = false;
      const keepUnavailable = () => {
        if (!addButton.disabled) addButton.disabled = true;
        if (addButton.getAttribute('aria-disabled') !== 'true') addButton.setAttribute('aria-disabled', 'true');
        const label = addButton.querySelector('[data-add-label]');
        if (label) label.textContent = 'SOLD OUT';
      };
      keepUnavailable();
      new MutationObserver(keepUnavailable).observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-snowflake-photo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('.sf__file'))return;var input=event.target;var panel=input.closest('.sf__form').querySelector('.sf__photo-preview');var image=panel.querySelector('img');var label=panel.querySelector('span');if(image.dataset.url)URL.revokeObjectURL(image.dataset.url);if(input.files&&input.files[0]){var url=URL.createObjectURL(input.files[0]);image.src=url;image.dataset.url=url;label.textContent=input.files[0].name;panel.hidden=false}else{image.removeAttribute('src');label.textContent='';panel.hidden=true}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vintage-active-details"] && !Shopify.designMode) return;
  try {
    
  const vintageSection = document.querySelector('.vintage-details[data-sold-out="true"]');
  if (vintageSection) {
    const notice = vintageSection.querySelector('.vintage-details__stock-notice');
    const addButton = document.querySelector('[data-add-button]');
    if (notice && addButton) {
      addButton.before(notice);
      notice.hidden = false;
      const keepUnavailable = () => {
        if (!addButton.disabled) addButton.disabled = true;
        if (addButton.getAttribute('aria-disabled') !== 'true') addButton.setAttribute('aria-disabled', 'true');
        const label = addButton.querySelector('[data-add-label]');
        if (label) label.textContent = 'SOLD OUT';
      };
      keepUnavailable();
      new MutationObserver(keepUnavailable).observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
